export default __webpack_public_path__ + "static/media/Pistol_8.c7217c3a.png";